import React from "react";
import "../Class/index.scss";

const Class = () => {
  return (
   <>
    <section id="class">
      <div className="container">
        <div className="class">
            <h4><span>Главная /</span> Мастер классы</h4>
             <h1>Мастер классы</h1>
             <div className="class--block">
                <h2>Реактивное программирование на Java: как, зачем и стоит ли? </h2>
                <p>Программирования появилась сравнительно недавно, лет 10 назад. Что вызвало популярность этого <br />относительно нового подхода и почему сейчас он в тренде, рассказал на конференции РИТ++ ...</p>
             </div>
             <div className="class--block">
                <h2>Олимпиада для айтишников: как мотивировать молодых разработчиков</h2>
                <p>В современном HR широко распространены событийные мотивационные мероприятия, как внешние, так и внутренние – различные социальные проекты, выставки, праздники, мастер-классы и тренинги, спортивные и ЗОЖ.</p>
             </div>
             <div className="class--block">
                <h2>Семинар Дино Эспозито “Real-time Data Coming at Last in ASP.NET Core”</h2>
                <p>Евангелистом разработки под Android и на Kotlin в JetBrains, а также членом команды, которая ведет WURFL, базу данных с информацией о мобильных устройствах, которая используется такими компаниями....</p>
             </div>
             <div className="class--block">
                <h2>DevOps конференция в Москве</h2>
                <p>Сборки на Jenkins с закрытыми глазами? А настроить Docker без смс, переплат и регистрации? Что будет, если билд соберется в течение одной миллисекунды? Эти и другие паранормальные явления слетятся обсудить более 400 человек...</p>
             </div>
             <div className="class--block">
                <h2>Олимпиада для айтишников: как мотивировать молодых разработчиков</h2>
                <p>В современном HR широко распространены событийные мотивационные мероприятия, как внешние, так и внутренние – различные социальные проекты, выставки, праздники, мастер-классы и тренинги, спортивные и ЗОЖ.</p>
             </div>
             <div className="class--block">
                <h2>Как научиться учиться.</h2>
                <p>Только за своим столом, но и в других местах - чтобы в непривычной ситуации нужная информация не вылетела из головы. Перед экзаменом, тестом, сертификацией можно повторять “по нарастающей” - каждый день чуть больше, чем в предыдущий...</p>
             </div>
        </div>
      </div>
    
    </section>
    
   </>
  );
};

export default Class;
